export default __webpack_public_path__ + "static/media/coderwall.a18e88fa.webp";